// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from "../shared/shared.module";

// component
import { DevSettingsComponent } from "./dev-settings.component";

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    DevSettingsComponent
  ]
})
export class DevSettingsModule { }